import { useState } from "react";
import { useAppStore } from "../../store/useAppStore";

export function SiteSwitcher({ dark = false }: { dark?: boolean }) {
  const [open, setOpen] = useState(false);
  const sites = useAppStore((s) => s.sites);
  const activeSiteId = useAppStore((s) => s.demo.activeSiteId);
  const switchSite = useAppStore((s) => s.switchSite);
  const active = sites.find((s) => s.id === activeSiteId)!;

  return (
    <div className="relative">
      <button
        type="button"
        className={`touch-target flex items-center gap-1.5 rounded-sm border px-3 py-1.5 font-action text-[13px] font-bold ${
          dark ? "border-navyBorder bg-navy2 text-white" : "border-border bg-card text-foreground"
        }`}
        aria-haspopup="listbox"
        aria-expanded={open}
        onClick={() => setOpen((o) => !o)}
      >
        <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" aria-hidden="true">
          <path d="M12 21s-7-5.5-7-11a7 7 0 0 1 14 0c0 5.5-7 11-7 11z" />
          <circle cx="12" cy="10" r="2.5" />
        </svg>
        {active.name}, {active.state}
        <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" aria-hidden="true">
          <polyline points="6 9 12 15 18 9" />
        </svg>
      </button>
      {open && (
        <ul
          role="listbox"
          aria-label="Choose site"
          className="absolute right-0 z-20 mt-1 w-56 rounded-md border border-border bg-card py-1 shadow-elevation-2"
        >
          {sites.map((site) => (
            <li key={site.id}>
              <button
                type="button"
                role="option"
                aria-selected={site.id === activeSiteId}
                onClick={() => {
                  switchSite(site.id);
                  setOpen(false);
                }}
                className={`flex w-full flex-col items-start px-3 py-2 text-left hover:bg-muted ${
                  site.id === activeSiteId ? "bg-brand-pale-blue" : ""
                }`}
              >
                <span className="font-action text-[13px] font-bold text-foreground">
                  {site.name}, {site.state}
                </span>
                <span className="font-mono text-[10.5px] text-muted-foreground">
                  {site.buildingCount} buildings · {site.unitCount} units
                </span>
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
